import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceCreateProjectModelFromProjectNotificationState = createStateReducer(
  initialState,
  {
    [events.createProjectModelFromProjectSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectModelFromProject",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createProjectModelFromProjectFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectModelFromProject",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceCreateProjectModelFromProjectNotificationState };
